var React = require('react');

function WideChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2327.253,439.233l-13.671-25.073a5.024,5.024,0,1,0-8.821,4.81l12.391,22.724-12.391,22.724a5.024,5.024,0,1,0,8.821,4.81l13.671-25.073a5.269,5.269,0,0,0,0-4.923Z","transform":"translate(471.848 -2304.147) rotate(90)","fill":"#ce2d4f"}));
}

WideChevronDown.defaultProps = {"data-name":"chevron","width":"60.307","height":"23.717","viewBox":"0 0 60.307 23.717"};

module.exports = WideChevronDown;

WideChevronDown.default = WideChevronDown;
